import { render, staticRenderFns } from "./titulo-seccion-icono.vue?vue&type=template&id=3c9213fb&scoped=true&"
import script from "./titulo-seccion-icono.vue?vue&type=script&lang=ts&"
export * from "./titulo-seccion-icono.vue?vue&type=script&lang=ts&"
import style0 from "./titulo-seccion-icono.vue?vue&type=style&index=0&id=3c9213fb&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c9213fb",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSheet } from 'vuetify/lib/components/VSheet';
import { VSpacer } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCard,VCol,VIcon,VRow,VSheet,VSpacer})
